import { Message } from 'element-ui'
export const imageUrl = (location.hostname.indexOf('dev') > -1 || location.hostname.indexOf('localhost') > -1) ? 'https://devimage.mygctong.com/' : 'https://myimage.mygctong.com/'
// export const imageUrl = 'https://devimage.szzsfx.com/'
/*
* 显示提示
*/
export const showmsg = (msg: string, type: 'success' | 'warning' | 'info' | 'error' = 'warning') => {
    Message({ type: type, message: msg })
}

export const getLastDay = (year: number, month: number) => {
    let new_year = year;    //取当前的年份
    let new_month = month++;//取下一个月的第一天，方便计算（最后一天不固定）
    if (month > 12) {
      new_month -= 12;        //月份减
      new_year++;            //年份增
    }
    const new_date = new Date(new_year, new_month, 1);                //取当年当月中的第一天
    return (new Date(new_date.getTime() - 1000 * 60 * 60 * 24)).getDate();//获取当月最后一天日期
  }


/*
* 验证手机号
*/
export const checkPhone = (phone: string) => {
    if (!phone) {
        showmsg('请输入手机号')
        return false
    }
    if (phone.length !== 11) {
        showmsg('手机号长度不正确')
        return false
    }
    if (!(/^1[3456789]\d{9}$/.test(phone))) {
        showmsg('手机号格式不正确')
        return false
    }
    return true
}
